import TabItem from '@/molecules/Tabs/TabItem';
import { TabsProps } from '@/molecules/Tabs/TabItem/types';
import TabsContainer from '@/molecules/Tabs/TabsContainer';
import { useRouter } from 'next/router';
import useTabsLink from './useTabsLink';

const TabsLink = ({ items, className, shallowRouting }: TabsProps<string>) => {
  const { itemsWithParam } = useTabsLink({ items });
  const { asPath } = useRouter();

  return (
    <TabsContainer className={className}>
      {itemsWithParam.map((item) => {
        const cleanedAsPath = (() => {
          // Extraire la partie query string de asPath
          const [pathWithoutQuery, queryString] = decodeURI(asPath).split('?');

          if (!queryString) {
            return pathWithoutQuery.replace(/\//gi, '');
          }

          // Manipuler les query params avec URLSearchParams
          const queryParams = new URLSearchParams(queryString);
          queryParams.delete('page'); // Supprimer le paramètre page

          const queryStringCleaned = decodeURIComponent(queryParams.toString());

          // Reconstruire l'URL sans ajouter '?' si queryStringCleaned est vide
          return queryStringCleaned
            ? `${pathWithoutQuery}?${queryStringCleaned}`.replace(/\//gi, '')
            : pathWithoutQuery.replace(/\//gi, '');
        })();

        return (
          <TabItem
            {...item}
            key={item.value}
            isActive={
              typeof item.isActive !== 'undefined' ? !!item.isActive : cleanedAsPath === item.href?.replace(/\//gi, '')
            }
            shallowRouting={shallowRouting}
          />
        );
      })}
    </TabsContainer>
  );
};

export default TabsLink;
